import subscribeToPrimeNotification from './subscribeToPrimeNotification';
import { applyOptions } from '../actions/activityFeedApplyOptions';
import { isFeatureEnabled } from 'owa-feature-flags';
import { initializeFileTypeIcons } from '@uifabric/file-type-icons';
import loadActivityFeedSettings from './loadActivityFeedSettings';
initializeFileTypeIcons();

export interface InitializeActivityFeedParameters {
    isOpx?: boolean;
}

export function initializeActivityFeed(params?: InitializeActivityFeedParameters) {
    var isOpx = params?.isOpx ?? false;
    if (isFeatureEnabled('auth-activityFeed')) {
        applyOptions();
        loadActivityFeedSettings();
        if (isFeatureEnabled('auth-activityFeedPrimeNotification')) {
            subscribeToPrimeNotification(isOpx);
        }
    }
}
